import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { DocOs } from '~/features/report-templates/os/doc-os';
import { useDocRights } from '~/features/report-templates/use-doc-rights';
import { useTemplate } from '~/features/report-templates/use-template';

import { useActiveTenant } from '@/hooks/use-active-tenant';

/**
 * Edit with OS (board use-Edit; step 8.3 of docs/plans/report-templates.md): the template chat on the saved
 * template. Held as the tab's Edit with OS is (`mayMake`): anyone else lands on the template's own page.
 */
function EditTemplateRoute(): ReactElement | null {
  const { recordId, templateId } = Route.useParams();
  const { mayMake } = useDocRights(recordId);
  if (!mayMake) return <Navigate to="/records/$recordId/report-templates/$templateId" params={{ recordId, templateId }} replace />;
  return <EditTemplate recordId={recordId} templateId={templateId} />;
}

function EditTemplate({ recordId, templateId }: { recordId: string; templateId: string }): ReactElement | null {
  const { tenantId } = useActiveTenant();
  const state = useTemplate(tenantId, templateId);
  if (state.status !== 'ready') return null;
  const { template } = state;
  return <DocOs recordId={recordId} template={{ id: template.id, name: template.name, version: template.version }} starter={null} />;
}

export const Route = createFileRoute('/_app/records/$recordId/report-templates/$templateId/edit')({ component: EditTemplateRoute });
